import { useEffect, useState } from "react";
import React from "react";
import { Link } from "react-router-dom";
import Api from "../../Api/Api";
import { username } from "../../API"; // If username is not used, consider removing it.
import "./WatchList.css"; // Ensure the CSS file for WatchList is imported

const WatchList = () => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true); // Added loading state
  const [error, setError] = useState(null); // Added error state

  useEffect(() => {
    const getData = async () => {
      try {
        const { video } = await Api.getWatchList();
        setVideos(video);
      } catch (err) {
        console.error("Error fetching watchlist:", err);
        setError("Failed to load the watchlist. Please try again.");
      } finally {
        setLoading(false);
      }
    };
    getData();
  }, []);

  if (loading) {
    return (
      <div className="loading-indicator watchlist-slider">
        <div className="loader"></div>
        <p>Loading Watchlist...</p>
      </div>
    );
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  // if (!videos || videos.length === 0) {
  //   return <div className="empty-message watchlist-slider">Your watchlist is empty.</div>;
  // }

  return (
    <div className="watchlist-home">
      {videos.length !== 0 && <h5 className="watchlist-title">WatchList</h5>}
      <div className="watchlist-slider">
        {videos.map((movie, index) => (
          <Link to={`/view/${movie._id}`} className="movie-link" key={index}>
            <div className="movie-card">
              <img
                src={`${movie.thumbnail}`}
                alt={`${movie.title}`}
                className="movie-thumbnail"
              />
              <div className="movie-info">
                <span className="movie-title">{movie.title}</span>
                {/* <span className="movie-languages">
                  <small>
                    {movie.Languages?.slice(0, 15) || "English"}
                    {movie.Languages?.length > 15 && `...`}
                  </small>
                </span> */}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default WatchList;
